import React from 'react';

import type { Props } from '@/components/SessionAvailabilityPill/types';
import { Tooltip } from '@/ui';

const tooltipContent = (isWithinPersonAvailability: boolean | null, memberFirstName: string) => {
  const name = <span className="mp-sensitive">{memberFirstName}</span>;
  if (isWithinPersonAvailability === true) return <>{name} is available at this time</>;
  if (isWithinPersonAvailability === false) return <>{name} is not available at this time</>;
  return <>No availability on file for {name}</>;
};

const SessionAvailabilityPill = ({
  children,
  isWithinPersonAvailability,
  memberFirstName
}: Props) => (
  <Tooltip content={tooltipContent(isWithinPersonAvailability, memberFirstName)}>
    {children}
  </Tooltip>
);

export default React.memo(SessionAvailabilityPill);
